module.exports = __webpack_public_path__ + "img/app-status.a933e337.jpg";